import script from "./OtherRequestFacebookPageAccessForm.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherRequestFacebookPageAccessForm.vue?vue&type=script&setup=true&lang=js"

import "./OtherRequestFacebookPageAccessForm.vue?vue&type=style&index=0&id=8e25ad68&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e25ad68"]])

export default __exports__